/**
 * @file ThemeToggledWrapper.js
 * @module src/js/components/ThemeToggledWrapper
 * @description
 * **A wrapper component that toggles styles based on the current theme.**
 * - Applies different styles for light and dark themes.
 * - Smoothly transitions between themes.
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-02: Parameterized transition duration based on ThemeProvider. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { useTheme } from "../contexts/ThemeProvider";

export default function ThemeToggledWrapper({
    id,
    children,
    lightStyle,
    darkStyle,
}) {
    const { theme, themeTransitionDuration } = useTheme();

    return (
        <section
            id={id}
            className={`wrapper style${theme === "dark" ? darkStyle : lightStyle}`}
            style={{ transition: `all ${themeTransitionDuration}s ease-in-out` }}
        >
            {children}
        </section>
    );
}
